<!-- image-preview.component.html -->
<div class="overlay" *ngIf="imageUrl">
  <div class="image-container">
    <img [src]="imageUrl" alt="Preview Image" />
    <button class="close-btn" (click)="onCloseClick()">×</button>
  </div>
</div>
